export enum ACTION_BUTTONS {
	BUY = "buy",
	SELL = "sell",
	SEND = "send",
	DEPOSIT = "deposit",
	WITHDRAW = "withdraw"
}
